import React, { useState, useEffect } from "react";
import '../../css/dashboard.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useNavigate } from "react-router-dom";
import logo from '../../images/24k1.jpg';
import AddProperty from "./AddProperty";
import { getAuthToken, logout } from "../Auth.js";
import { Welcomeadmin } from "./Welcomeadmin.js";


const Dashboard = () => {
  const navigate = useNavigate();
  const [agentId, setAgentId] = useState(null);
  const [agentName, setAgentName] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const agent_id = localStorage.getItem("agent_id");
    const agent_name = localStorage.getItem("agent_name");

    if (!token) {
      console.warn("No token found, redirecting to login...");
      navigate("/login");
      return;
    }  

    console.log("Stored Agent ID:", agent_id || "❌ Missing agent_id!");
    console.log("Stored Agent Name:", agent_name || "❌ Missing agent_name!");

    if (agent_id) {
      setAgentId(agent_id);  
      sessionStorage.setItem("agent_id", agent_id); 
    }
    if (agent_name) {
      setAgentName(agent_name);
      sessionStorage.setItem("agent_name", agent_name);
    }
  }, [navigate]);


  
  return (
    <div>
      <Navbar key="sm" expand="sm" className="navbar">
        <Container fluid>
          <Navbar.Brand href="#" className="nav-brand">
            <img onClick={(e) =>{navigate('/')}} src={logo} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="offcanvasNavbar-expand-sm" />
          <Navbar.Offcanvas
            id="offcanvasNavbar-expand-sm"
            aria-labelledby="offcanvasNavbarLabel-expand-sm"
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel-expand-sm" className="nav-title">
                Agent Dashboard
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3 nav-menu">
                
                <Nav.Link  className="color" onClick={() => { navigate("/listings")}}>Listings</Nav.Link>
                
                <button onClick={() => { navigate("/Newproject")}}>
                  <Nav.Link className="w-color">+ New Project</Nav.Link>
                </button>
                <button onClick={() => { navigate("/pg-co-living")}}>
                  <Nav.Link className="w-color">+ New Listing</Nav.Link>
                </button>
                <Nav.Link  onClick={() => { logout()}} className="color logout">Logout</Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
};

export default Dashboard;
